import type { Project } from '../data/projectTypes'

// A project has "connected an issue tracker" once it has an issue_tracker configuration. Connecting via
// the chat card always stores one (with enabled: true) and disconnecting clears it back to null, so a
// non-null value is the signal that the "Connect Issue Tracker" CTA is no longer needed.
export function isIssueTrackerConnected(project: Project | null | undefined): boolean {
  return Boolean(project?.issue_tracker)
}
